export const MOCK_DATA: Record<string, any>[] = [
  {
    "display_name": "TestCreateAttr",
    "status": "ACTIVE",
    "type": "PARTNER",
    "id": "7f3f7af7-f01f-43e4-8fcc-822fc637bcb9",
    "attribution_guid": "2d2bda05-33fd-4bb5-96dc-e178831bda91",
    "created_date": "2026-07-30T05:04:11.807Z",
    "updated_date": "2026-07-30T05:04:11.807Z",
    "schema_data_id": "f1e1510e-4359-4ab7-bfe5-302d64a634c5"
  },
  {
    "schema_data_id": "24f8590a-1b10-43a1-98f6-5ff0ddcbc315",
    "display_name": "QE: TestMockQE - QUOTE_EXPERIENCE_COLORS",
    "status": "ACTIVE",
    "type": "QUOTE_EXPERIENCE_COLORS",
    "id": "cd35ae00-58e4-4130-90f3-6c002d497011",
    "attribution_guid": "77c64569-703c-4a31-a9e4-a8851d6f62ad",
    "created_date": "2026-07-31T05:34:14.300Z",
    "updated_date": "2026-07-31T05:34:14.300Z"
  },
  {
    "schema_data_id": "e3f7f550-cf3a-4a6f-a344-4d86bd90b27f",
    "display_name": "QE: TestMockQE - QUOTE_EXPERIENCE_CONFIG",
    "status": "ACTIVE",
    "type": "QUOTE_EXPERIENCE_CONFIG",
    "id": "91a157f8-a478-4922-a25e-4675a7557f2b",
    "attribution_guid": "42073816-a74c-4baf-96b1-193f61bef14c",
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z"
  },
  {
    "schema_data_id": "5bd409c4-6e75-4437-936b-669ef160a97a",
    "display_name": "QE: TestMockQE - QUOTE_EXPERIENCE_ICONS",
    "status": "ACTIVE",
    "type": "QUOTE_EXPERIENCE_ICONS",
    "id": "e8b291a9-052b-416f-8d2f-259b2342ee30",
    "attribution_guid": "b68c38da-c36c-4d3c-9e31-2d6b0d766911",
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z"
  },
  {
    "schema_data_id": "f5d0b3d2-6abd-42c1-9d0c-8c1d5bc73356",
    "display_name": "QE: TestMockQE - QUOTE_EXPERIENCE_IMAGES",
    "status": "ACTIVE",
    "type": "QUOTE_EXPERIENCE_IMAGES",
    "id": "71899e52-1584-446d-b6ae-79b17d7a1e99",
    "attribution_guid": "dfe2a64e-1dcc-4646-9456-036e064898b2",
    "created_date": "2026-07-31T05:34:14.301Z",
    "updated_date": "2026-07-31T05:34:14.301Z"
  },
  {
    "schema_data_id": "160357de-7040-42fc-b50f-3480f65838bd",
    "display_name": "QE: TestMockQE - QUOTE_EXPERIENCE_LOCALIZATIONS",
    "status": "ACTIVE",
    "type": "QUOTE_EXPERIENCE_LOCALIZATIONS",
    "id": "871bd527-e0ae-4f2a-b958-c31cf2828574",
    "attribution_guid": "d2b880d8-01e1-4142-bcf9-8a5b6cdba041",
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z"
  },
  {
    "schema_data_id": "a6b880eb-af85-41e3-805b-8922bc27e1b5",
    "display_name": "QE: TestMockQE - QUOTE_EXPERIENCE_TYPOGRAPHY",
    "status": "ACTIVE",
    "type": "QUOTE_EXPERIENCE_TYPOGRAPHY",
    "id": "ffcb16cb-75af-4db8-b970-b4fbc2184a14",
    "attribution_guid": "417fd7cb-ebfd-4203-9a65-45c5275b3fb6",
    "created_date": "2026-07-31T05:34:14.302Z",
    "updated_date": "2026-07-31T05:34:14.302Z"
  }
];